import { PLATFORM_ALERT } from '../constant/actionTypes';

const getPlatformAlertList = (state, action) => {
  switch (action.type) {
    case PLATFORM_ALERT.DATA.INITIATE:
      return { isFetching: true, data: action.payload };
    case PLATFORM_ALERT.DATA.SUCCESS:
      return { isFetching: false, data: action.payload };
    case PLATFORM_ALERT.DATA.ERROR:
      return { isFetching: false, data: action.payload };
    default:
      return state || [];
  }
};

export default getPlatformAlertList;
